import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ScoringDimensionPeriodListContainer from "./ScoringDimensionPeriodListContainer";
import ScoringIndicatorListRowComponent from "./ScoringIndicatorListRowComponent";
import { Icon, Table, TableBody, TableHead, TableRow, Grid } from "@mui/material";
import { IconButton } from "@totalsoft/rocket-ui";
import { BoldCell } from "components/common/TableStyles";

const ScoringIndicatorListComponent = ({
  showModal,
  indicatorList,
  periodList,
  dimensionPeriods,
  disabled,
  onOpenDimensionListModal,
  handleFinancialIndicatorValueChange,
  onCloseDimensionListModal,
  isHistory
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <BoldCell>{t("Scoring.ScoringIndicator.Indicator")}</BoldCell>
            {periodList.length > 0 &&
              periodList.map(period => (
                <BoldCell key={period.documentScoringFinancialIndicatorPeriodDimensionId}>
                  {period.dimensionId
                    ? period.dimensionPeriodName + " (" + period.dimensionName + ")"
                    : period.dimensionPeriodName}
                </BoldCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {indicatorList.length > 0 &&
            indicatorList.map(({ document }, idx) => {
              return (
                <ScoringIndicatorListRowComponent
                  key={document.scoringFinancialIndicatorId}
                  idx={idx}
                  indicator={document}
                  periodList={periodList}
                  disabled={disabled}
                  onFinancialIndicatorValueChange={handleFinancialIndicatorValueChange}
                />
              );
            })}
        </TableBody>
      </Table>

      <ScoringDimensionPeriodListContainer
        showModal={showModal}
        onCloseDimensionListModal={onCloseDimensionListModal}
        dimensions={dimensionPeriods}
        indicatorList={indicatorList}
        periods={periodList}
      />

      {!isHistory && (
        <Grid container justifyContent="end" mt={2}>
          <IconButton
            color="info"
            onClick={onOpenDimensionListModal}
            disabled={disabled}
            tooltip={t("Scoring.ScoringIndicator.Dimensions.AddDimension")}
          >
            <Icon>edit_icon</Icon>
          </IconButton>
        </Grid>
      )}
    </>
  );
};

ScoringIndicatorListComponent.propTypes = {
  isValid: PropTypes.bool.isRequired,
  indicatorList: PropTypes.array.isRequired,
  periodList: PropTypes.array.isRequired,
  dimensionPeriods: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onOpenDimensionListModal: PropTypes.func.isRequired,
  handleFinancialIndicatorValueChange: PropTypes.func.isRequired,
  onCloseDimensionListModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  documentScoringGridId: PropTypes.number.isRequired,
  isHistory: PropTypes.bool
};

export default ScoringIndicatorListComponent;
